import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { Home } from '../home';
import { CommonService } from './service/common.service';
import { Common } from './model/common.model';

declare var $: any;

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss']
})
export class CommonComponent extends Home implements OnInit {

  @ViewChild('f') form;

  commons: any;
  get: Subscription;
  put: Subscription;
  post: Subscription;

  isLoading: boolean = false;

  constructor(private commonService: CommonService, private router: Router, public common: Common) {
    super(router);
  }

  ngOnInit() {
    this.list();
  }

  list() {
    this.isLoading = true;
    this.get = this.commonService.get()
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.commons = ret.items;
        }
        this.isLoading = false;
      },
        err => {
          console.log(err);
          this.isLoading = false;
          this.allowAcess(err.status);
        });
  }

  doCommon(common: Common, valid: boolean) {

    if (!valid)
      return;

    if (!common.id) {
      this.doCreated(common);
    } else {
      this.doUpdated(common);
    }
  }

  doUpdated(comm) {

    this.put = this.commonService.put(comm.id, comm)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro atualizado com sucesso.', 'success');
          this.clean();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  doCreated(comm) {

    this.post = this.commonService.post(comm)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro cadastrado com sucesso.', 'success');
          this.clean();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  loadRegister(id) {
    this.common = this.commons.find(f => f.id == id);
    $('#myModal').modal('show');
  }

  clean() {
    this.common = new Common();
    this.form.resetForm();
  }

  ngOnDestroy() {
    if (this.get)
      this.get.unsubscribe();

    if (this.put)
      this.put.unsubscribe();

    if (this.post)
      this.post.unsubscribe();
  }
}